import SettingsShell from "@/modules/settings/SettingsShell";
import { Button, Container, Grid, Group, Skeleton, Stack } from "@mantine/core";
import "leaflet/dist/leaflet.css";

import EditGallery from "@/modules/gallery/EditGallery";
import ImageItem from "@/modules/gallery/ImageItem";
import GalleryCaption from "@/modules/gallery/GalleryCaption";
import { useGetAllGalleryImages } from "@/services/gallery/utilities";
import { useDisclosure } from "@mantine/hooks";
import useIsSmall from "@/hooks/useIsSmall";

function EditProfileGallery() {
  const [opened, { open, close }] = useDisclosure(false);
  const { data, isLoading } = useGetAllGalleryImages();
  const isSmall = useIsSmall();

  return (
    <>
      <SettingsShell title="گالری تصاویر" description="عکس‌های سالن روی سایت رزرو؛ توضیح هر عکس به گوگل کمک می‌کند آن را بفهمد.">
        <Container size="md" w="100%" px={0}>
          <Stack
            px="lg"
            w="100%"
            styles={{
              root: {
                flexGrow: 1,
              },
            }}
          >
            <Stack gap="lg">
              <Group justify="space-between">
                <span />
                <Button variant="default" radius="xl" size="xs" onClick={open}>
                  ویرایش
                </Button>
              </Group>

              {isLoading ? (
                <Stack>
                  <Grid gutter="md">
                    {[1, 2, 3]?.map((_, index) => (
                      <Grid.Col key={index} span={index === 0 ? 12 : 6}>
                        <Skeleton
                          w="100%"
                          h={
                            index === 0
                              ? isSmall
                                ? 150
                                : 500
                              : isSmall
                                ? 100
                                : 300
                          }
                        />
                      </Grid.Col>
                    ))}
                  </Grid>
                </Stack>
              ) : (
                <Stack>
                  <Grid gutter="md">
                    {data?.map((image, index) => (
                      <Grid.Col key={index} span={index === 0 ? 12 : 6}>
                        <Stack gap={6}>
                        <ImageItem
                          key={image.id}
                          image={image.image || {}}
                          h={
                            index === 0
                              ? isSmall
                                ? 150
                                : 500
                              : isSmall
                                ? 100
                                : 300
                          }
                        />
                        <GalleryCaption key={`${image.id}-${image.caption ?? ""}`} id={image.id} caption={image.caption} />
                        </Stack>
                      </Grid.Col>
                    ))}
                  </Grid>
                </Stack>
              )}
            </Stack>
          </Stack>
        </Container>
      </SettingsShell>

      <EditGallery opened={opened} close={close} />
    </>
  );
}

export default EditProfileGallery;
